import React from "react";
import CacheBuster from "react-cache-buster";
import packageJson from '../package.json';
import Main from "./Main";
import CacheLoading from "./CacheLoading";
import "./css/App.css";

const App = () => {
	const { version } = packageJson;
	const isEnabled = ['local', 'dev', 'staging', 'production'].includes(process.env.REACT_APP_ENV);

    return (
        <CacheBuster
            currentVersion={ version }
            isEnabled={ isEnabled }
            isVerboseMode={ false }
            loadingComponent={ <CacheLoading /> }
            metaFileDirectory={ '.' }
            onCacheClear={ null }
        >
            <Main />
        </CacheBuster>
    )
}

export default App;